module.exports = __webpack_public_path__ + "static/img/bb5.2dc8e3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bb5.png
// module id = IHXC
// module chunks = 2